import React from 'react';

const LoadingDots: React.FC = () => {
  return (
    <svg
      height="30"
      width="40"
    >
      <defs>
        <style>
          {`
            @keyframes blink {
              50% {
                fill: transparent
              }
            }
            .dot {
              animation: 1s blink infinite;
              fill: grey;
            }
            .dot:nth-child(2) {
              animation-delay: 250ms
            }
            .dot:nth-child(3) {
              animation-delay: 500ms
            }
          `}
        </style>
      </defs>
      <circle
        className="dot"
        cx="10"
        cy="15"
        r="3"
        style={{ fill: 'grey' }}
      />
      <circle
        className="dot"
        cx="20"
        cy="15"
        r="3"
        style={{ fill: 'grey' }}
      />
      <circle
        className="dot"
        cx="30"
        cy="15"
        r="3"
        style={{ fill: 'grey' }}
      />
    </svg>
  );
};

export default LoadingDots;